// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  mobileBreakpoint: "600px",
  production: false,
  teamAssetsUrl: "https://realmadrid-static.geographica.gs",
  teamUrl:
    "https://publish-p47754-e237306.adobeaemcloud.com/content/dam/common/statics/public-content/badge/basket",
  playerUrl: "https://publish-p47754-e237306.adobeaemcloud.com/players/basket",
  carto: {
    env: "dev",
    envPrefix: "dev_",
    tablePreffix: "carto-ps-realmadrid-eu-dev.dev.",
    baseUrl: "https://gcp-europe-west1.api.carto.com/v3/sql",
    connection: "dev_read_app",
    public_access_token:
      "eyJhbGciOiJIUzI1NiJ9.eyJhIjoiYWNfYnkzNzdhNTEiLCJqdGkiOiIwYzI1YmIyNiJ9.h4Tf-HTFUG1i-jSZsilsp-_HwZoXwPXpVblDtH84j9s",
  },
};
